module.exports = __webpack_public_path__ + "static/DC4-e44e00aa144f501b3640a4da0475283e.jpg";